module.exports = __webpack_public_path__ + "static/media/shield-ok.259b197b.svg";